import React from "react";
import "../../../styles/login.css";
import GoogleLoginButton from "../../../components/GoogleLoginButton/GoogleLoginButton";
import { googleLogin, verifyJwt } from "../../../api/authApi";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";

function AdminLoginPage() {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleGoogleSuccess = async (googleIdToken) => {
    try {
      // Step 1: Google → Backend → JWT
      const res = await googleLogin(googleIdToken);
      const jwt = res.data.jwt;

      // Step 2: Verify JWT & get user info
      const verifyRes = await verifyJwt(jwt);
      const userData = verifyRes.data;

      // Step 3: Enforce ADMIN role
      if (userData.role !== "ADMIN") {
        alert("Access denied: Admins only");
        return;
      }

      // Step 4: Login + redirect
      login(jwt, userData);
      navigate("/admin/dashboard");

    } catch (error) {
      console.error("Admin login failed:", error);
      alert("Admin login failed");
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Admin Login</h2>

      <GoogleLoginButton onGoogleSuccess={handleGoogleSuccess} />
    </div>
  );
}

export default AdminLoginPage;
